import styled from 'styled-components';
import ThemeHelper from '../../themes/theme-helper';
import { flexShrink, flexbox } from '../../styles/helpers/flexbox';

const grid = 8;
const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    padding: grid * 2,

    // change background colour if dragging
    background: isDragging ? 'lightgreen' : 'white',

    // styles we need to apply on draggables
    ...draggableStyle
});

const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? 'lightblue' : 'white',
    padding: grid,
    overflowY: 'scroll',
    maxHeight: '80vh',
    position: 'relative'
});

const SpineListWrapper = styled.div((props) => {
    const { palette, typography } = ThemeHelper.getTheme(props);

    return `
    height: 100%;
    overflow: auto;
    padding: 5px;
    font-family: ${typography.family};
    color: ${palette.primary.dark};
    
    .spacer {
        padding: 2px;
    }
    `;
});

const SpineItemIconWrapper = styled.div`
    width: 24px;
    height: 25px;
    ${flexShrink(0)}
    padding-top: 12px;
    padding-left: 5px;
    cursor: pointer;
`;

const SpineItemNameWrapper = styled.div((props) => {
    const { colours, typography } = ThemeHelper.getTheme(props);

    return `
    ${flexShrink(0)}
    padding-left: 5px;
    color: ${colours.emperor};
    font-family: ${typography.family};
    padding-top: 13px;
    font-size: 14px;
    font-weight: 500;
    width: 85%;
    white-space: nowrap; 
    overflow: hidden;
    text-overflow: ellipsis;   
    `;
});

const SpineItemInfoWrapper = styled.div((props) => {
    const { colours, palette } = ThemeHelper.getTheme(props);

    return `
            ${flexbox()}
            height: 48px;
            border: 1px solid ${colours.silverDark};
            border-radius: 7px;
            box-shadow: 10px 5px 5px rgba(0, 0, 0, 0.1);
            background-color: ${palette.primary.text};
            margin: 8px 6px;
        `;
});

export {
    getItemStyle,
    getListStyle,
    SpineListWrapper,
    SpineItemIconWrapper,
    SpineItemNameWrapper,
    SpineItemInfoWrapper
};



// WEBPACK FOOTER //
// ./app/components/spine-list/styled.js